import React from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'

const DiscourseComments = ({ className }) => {
  useIsomorphicLayoutEffect(() => {
    const location = document.location.href?.split('?')?.[0]

    if (location && typeof location === 'string') {
      window.DiscourseEmbed = {
        discourseUrl: 'https://forum.strapi.io/',
        discourseEmbedUrl: location,
        discourseReferrerPolicy: 'strict-origin-when-cross-origin',
      }

      const d = document.createElement('script')
      d.type = 'text/javascript'
      d.async = true
      d.src = `${window.DiscourseEmbed.discourseUrl}javascripts/embed.js`
      ;(
        document.getElementsByTagName('head')[0] ||
        document.getElementsByTagName('body')[0]
      ).appendChild(d)
    }
  }, [])

  return <div className={className} id="discourse-comments" />
}

DiscourseComments.defaultProps = {}

export default DiscourseComments
